const $inject = ['$rootScope', '$scope', '$http', '$routeParams', 'dataService'];

const lbaConfirmButtonCtrl = function ($rootScope, $scope, $http, $routeParams, dataService) {
    const vm = this;
    vm.enabled = true;

    const debtorID = dataService.data.activeItem.Name;

    function checkEnabled() {
        if (vm.settings.enabledIf) {
            const dataLookUp = dataService.spiltDataAt(vm.settings.enabledIf, $routeParams);
            vm.enabled = _.get(dataService.data.activeItem, dataLookUp);        
        }
    }

    checkEnabled()

    $rootScope.$on('lbaLoader:loaderState', () => {
        checkEnabled();
    })


    vm.handleClick = function () {
        let confirm = window.confirm(vm.settings.confirmMessage);

        if (confirm) {
            $rootScope.$broadcast('lbaLoader:loaderState', {state: 'saving'});           
            $http.post(`${endPointUrl}${vm.settings.endpoint}${debtorID}`).then(res => {
                $rootScope.$broadcast('lbaLoader:loaderState', {state: 'loaded'});
            }).catch(err => {
                $rootScope.$broadcast('lbaLoader:loaderState', {state: 'error'});
            })
        }
    }
};

lbaConfirmButtonCtrl.$inject = $inject;

export default lbaConfirmButtonCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaConfirmButton/lbaConfirmButtonCtrl.js